import React, { useCallback, useEffect, useState } from 'react';
import { Calculator } from './components/Calculator';
import { CalculatorContainer } from './components/CalculatorContainer';
import { Calculator as CalculatorType } from './types/Calculator';

declare global {
  interface Window { xmachina: { calculators: CalculatorType[] } }
}
function App() {

  const [ calculators, setCalculators ] = useState<CalculatorType[]>()
  const [ , setLoadInterval] = useState<NodeJS.Timeout>()
  const [ tries, setTries ] = useState<number>( 0 )

  const loadCalculators = useCallback( () => {
    setLoadInterval( prev => {

      if( prev ) 
        clearInterval( prev )
      
      if( tries > ( process.env.MAX_DATA_LOAD_TRIES ?? 10 ) ) return

      if( calculators ) return
      
      return setInterval( () => {
        setTries( prev => prev + 1 )
        if(  window?.xmachina?.calculators  )
          setCalculators( window?.xmachina?.calculators )
      }, 2000 )

    })
    
  }, [ calculators, tries ] )

  useEffect( () => {
    loadCalculators()
  }, [ loadCalculators ] )

  return (
    <>
    {
      calculators?.map( c => (
        <CalculatorContainer key={ c.id } >
          <Calculator calculator={ c }  />
        </CalculatorContainer>
      ))
    }
    </>
  );
}

export default App;
